const markenSwiper = new Swiper(".marken-swiper", {
  slidesPerView: 1.5,
  spaceBetween: 20,
  freeMode: true,
  breakpoints: {
    1024: {
      spaceBetween: 32,
      slidesPerView: 4,
      navigation: {
        nextEl: ".marken-button-next",
        prevEl: ".marken-button-prev",
      },
    },
  },
});
